export enum Coloring {
  // colors
  NoColors = 0,
  FaceColors = 1,
  VertexColors = 2,
}